module.exports = __webpack_public_path__ + "img/51.8b52dfe6.png";